export default "__VITE_ASSET__BKr5tmTw__"